// extracted by mini-css-extract-plugin
export default {"alertContainer":"alertContainer--pKKIB","header":"header--DbmPj","right":"right--CwPty","title":"title--BdpUq","content":"content--e0O8B","bottomFooter":"bottomFooter--alXZx"};